<template lang="pug">
    Row
        Col(span="20")
            Table(border row-key="id" :columns="columns" :data="data" :no-data-text="$t('main.tableNoDataText')" :no-filtered-data-text="$t('main.tableNoFilteredDataText')" )
                template(slot-scope="{ row }" slot="showName" )
                    span {{$i18n.t(`routesMenu.${row.name}`)}}
                template(slot-scope="{ row }" slot="read")
                    Checkbox(:value="row.read" @on-change="(...args) => { onChange(row, 'read',...args)}")
                template(slot-scope="{ row,index }" slot="write")
                    Checkbox(:value="row.write" @on-change="(...args) => { onChange(row, 'write',...args)}" :disabled="!$store.getters.isAdmin ? !parentChildrenItems[index].write : false")
                template(slot-scope="{ row }" slot="other")
                    Row(v-for="(item,index) in Object.keys(row.other||{})" :key="index")
                        Checkbox(:value="row.other[item]" @on-change="(...args) => { onChange(row, `other.${item}`,...args)}" :disabled="!$store.getters.isAdmin ? !parentChildrenItems[index].other[item] : false") {{ $i18n.t(`rolesmanage.${item}`) }}
</template>
<script>
export default {
    props: ["formItem", "formData", "value"],
    data() {
        return {
            parentChildrenItems: [],
            columns: [
                {
                    title: "Page",
                    key: "name",
                    tree: true,
                    slot: "showName",
                },
                {
                    title: "Read",
                    key: "read",
                    slot: "read",
                },
                {
                    title: "Write",
                    key: "write",
                    slot: "write",
                },
                {
                    title: "Other",
                    key: "other",
                    slot: "other",
                },
            ],
            data: [],
            permissionCategory: [
                {
                    key: "dashboardPermission",
                    name: "Dashboards",
                },
                {
                    key: "domainManagePermission",
                    name: "Domains",
                },
                {
                    key: "groupResourcesPermission",
                    name: "GroupResource",
                },
                {
                    key: "intelligentProtectionPermission",
                    name: "IntelligentProtection",
                },
                {
                    key: "billingPermission",
                    name: "Billing",
                },
            ],
            defaultPermission: {},
        };
    },
    watch: {
        value: {
            deep: true,
            handler: function (val) {
                this.data = [];
                this.data.push(val);
                this.setIdAndOpenTableTree();
            },
        },
    },
    methods: {
        setIdAndOpenTableTree() {
            // 給定唯一值id：上一層的名稱＋自己名稱(用於判斷勾選的是哪個＆設置table tree的rowKey)
            this.data.map((e) => {
                e.id = e.name;
                e._showChildren = true;
                if (e.children) {
                    e.children.map((ele) => {
                        ele.id = e.name + "-" + ele.name;
                        // if (ele.children) {
                        //     ele.children.map(element => {
                        //         element.id = ele.name + "-" + element.name;
                        //         element.showName = element.name;
                        //         if (element.name !== "description") {
                        //             element.disabled = true;
                        //         }
                        //     });
                        // }
                    });
                }
            });
        },
        onChange(row, action, value) {
            this.data.filter((e) => {
                if (e.id == row.id) {
                    if (action.includes("other")) return;
                    //母項目勾選
                    e[action] = value;

                    if (action == "read" && value == true) {
                        //向下檢查若有子項目及欄位也能read
                        if (e.children) {
                            e.children.map((e) => {
                                e[action] = value;

                                // if (e.children) {
                                //     e.children.map(element => {
                                //         element[action] = value;
                                //     });
                                // }
                            });
                        }
                    }

                    if (action == "read" && value == false) {
                        // 母項目不能read時，也不能write
                        e.write = value;
                        //向下檢查若有子項目及欄位也不能read&write
                        if (e.children) {
                            e.children.map((e) => {
                                e[action] = value;
                                e.write = value;
                                // if (e.children) {
                                //     e.children.map(element => {
                                //         element[action] = value;
                                //         element.write = value;
                                //     });
                                // }
                            });
                        }
                    }

                    if (action == "write" && value == true) {
                        // 母項目能write時，也能read
                        e.read = value;
                        //向下檢查若有子項目及欄位也能read&write
                        if (e.children) {
                            e.children.map((e) => {
                                e[action] = value;
                                e.read = value;
                                // if (e.children) {
                                //     e.children.map(element => {
                                //         element[action] = value;
                                //         element.read = value;
                                //     });
                                // }
                            });
                        }
                    }

                    if (action == "write" && value == false) {
                        if (e.children) {
                            e.children.map((ele) => (ele[action] = value));
                        }
                    }
                } else {
                    let pagePermission = e.children.find((e) => e.id == row.id);
                    if (pagePermission) {
                        //子項目勾選
                        if (["read", "write"].includes(action)) {
                            pagePermission[action] = value;
                        }
                        if (action.includes("other")) {
                            const key = action.split(".")[1];
                            pagePermission.other[key] = value;
                        }
                        if (action.includes("other") && value == true) {
                            // 子項目可以執行 other 的操作時，至少需可以 read
                            pagePermission.read = value;
                        }
                        if (action == "read" && value == false) {
                            //子項目不能read時，也不能write
                            pagePermission.write = value;

                            e.read = !e.children.every((element) => element.read == false);
                            e.write = !e.children.every((element) => element.write == value);

                            //向下檢查若有欄位不能read&write
                            // if (pagePermission.children) {
                            //     pagePermission.children.map(element => {
                            //         element[action] = value;
                            //         element.write = value;
                            //     });
                            // }
                        }
                        if (action == "write" && value == true) {
                            //子項目能write時，也能read
                            pagePermission.read = value;
                            e.read = value;
                            //向下檢查若有欄位也能read&write
                            // if (pagePermission.children) {
                            //     pagePermission.children.map(element => {
                            //         element[action] = value;
                            //         element.read = value;
                            //     });
                            // }
                        }
                        if (action == "write" && value == false) {
                            e[action] = !e.children.every((element) => element[action] == value);
                            //向下檢查若有欄位不能read&write
                            // if (pagePermission.children) {
                            //     pagePermission.children.map(element => {
                            //         element[action] = value;
                            //     });
                            // }
                        }
                        //子項目other有勾起，母項目的read也要勾起
                        if (action.includes("other") && value == true) {
                            e.read = value;
                        }
                        //子項目read有勾起，母項目也要勾起
                        if (action == "read" && value == true) {
                            e[action] = value;
                        }
                        //子項目write有勾起，母項目也要勾起
                        if (action == "write" && value == true) {
                            e[action] = value;
                        }
                    } else {
                        // e.children.find(ele => {
                        //     if (ele.children) {
                        //         //欄位勾選
                        //         let paramsPermission = ele.children.find(element => element.id == row.id);
                        //         paramsPermission[action] = value;
                        //         //  欄位可以write時，read勾起
                        //         if (action == "write" && value == true) {
                        //             paramsPermission.read = value;
                        //             ele[action] = value;
                        //             e[action] = value;
                        //             ele.read = value;
                        //             e.read = value;
                        //         }
                        //         //欄位不能read時，也不能write
                        //         if (action == "read" && value == false) paramsPermission.write = value;
                        //         //欄位read勾起時，子項目＆母項目read也要勾起
                        //         if (action == "read" && value == true) {
                        //             e[action] = value;
                        //             ele[action] = value;
                        //         }
                        //     }
                        // });
                    }
                }
            });
            this.$emit("input", this.data[0]);
        },
        getPermissionCategory() {
            let permissionCategory = [];

            if (!this.$store.getters.isAdmin) {
                let rolePermissions = {};
                for (let permission in this.compareParentRolePermission()) {
                    if (this.compareParentRolePermission()[permission].read !== false) {
                        rolePermissions[permission] = this.compareParentRolePermission()[permission];
                    }
                }
                for (let permission in rolePermissions) {
                    permissionCategory.push(
                        this.permissionCategory.filter((category) => category.key == permission)[0]
                    );
                }
            } else {
                permissionCategory = this.permissionCategory;
            }
            return permissionCategory;
        },
        getOtherPermissions(item) {
            switch (item.showName) {
                case "CertsUpload":
                    return { downloadSystemCerts: false };
                default:
                    return {};
            }
        },
        setDefaultPermission() {
            let allItems = this.$store.getters.getMenuItems.map((item) => item.subItems).flat();
            this.getPermissionCategory().map((permission) => {
                this.defaultPermission[permission.key] = {
                    name: permission.name,
                    read: false,
                    write: false,
                    _showChildren: true,
                    children: [],
                };
                allItems.map((item) => {
                    if (item.requiredPermission == permission.key) {
                        this.defaultPermission[permission.key].children.push({
                            name: item.showName,
                            read: false,
                            write: false,
                            other: this.getOtherPermissions(item),
                        });
                    }
                });
            });
        },
        compareParentRolePermission() {
            let rolePermissions = {};
            var rolePermission = this.$store.state.userData.inGroupsRole.find(
                (role) => role.groupName == this.$store.state.queryGroupName
            );
            // return rolePermission[0].rolePermissions;
            if (rolePermission) {
                rolePermissions = rolePermission.rolePermissions;
            }
            return rolePermissions;
        },
        preprocessingEditData() {
            if (this.$store.getters.isAdmin) {
                if (this.value.children) {
                    this.value.children = this.value.children.map((childItem) => childItem);
                }
                this.data.push(this.value);
            } else {
                if (this.value.children) {
                    for (let permissionItem in this.compareParentRolePermission()) {
                        if (this.compareParentRolePermission()[permissionItem].name == this.value.name) {
                            var parentChildrenItems = this.compareParentRolePermission()[
                                permissionItem
                            ].children.filter((childItem) => childItem.read == true);

                            this.value.children = this.value.children.filter((originItem) =>
                                parentChildrenItems.some((filteredItem) => filteredItem.name === originItem.name)
                            );
                            this.parentChildrenItems = JSON.parse(JSON.stringify(this.value.children));
                        }
                    }
                }
                this.getPermissionCategory().map((permission) => {
                    if (permission.name == this.value.name) {
                        this.data.push(this.value);
                    }
                });
            }
        },
    },
    mounted() {
        this.setDefaultPermission();
        if (this.value == "" || this.value == undefined) {
            // create
            this.data.push(this.defaultPermission[this.formItem.key]);

            for (let permissionItem in this.compareParentRolePermission()) {
                if (
                    this.compareParentRolePermission()[permissionItem].name ==
                    this.defaultPermission[this.formItem.key].name
                ) {
                    var parentChildrenItems = this.compareParentRolePermission()[permissionItem].children.filter(
                        (childItem) => childItem.read == true
                    );
                    this.parentChildrenItems = JSON.parse(JSON.stringify(parentChildrenItems));
                }
            }
        } else {
            // edit
            this.preprocessingEditData();
        }
        this.setIdAndOpenTableTree();
        this.$emit("input", this.data[0]);
    },
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/TableCheckbox.vue